import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const analyticsV2ContainerStyles = makeStyles({
  mediumSize: {
    width: "626px",
    height: "356px",
    ...shorthands.margin("5px")
  },
  smallSize: {
    width: "308px",
    height: "356px",
    ...shorthands.margin("5px")
  },
  largeSize: {
    // TODO: (astripa) confirm if this works for all widgets
    width: "1264px",
    // width: "100%",
    ...shorthands.margin("5px")
  },
  tabs: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    fontSize: "200"
  },
  emptyState: {
    width: "200px",
    flexGrow: "1",
    ...shorthands.padding("5px")
  },
  emptyStateButton: {
    width: "100px"
  },
  tabTitleActiveCaption: {
    color: tokens.colorBrandForeground1,
    fontWeight: "bold"
  },
  viewDetailsButton: {
    color: tokens.colorBrandForeground2
  },
  viewDetailsButtonIcon: {
    margin: "2px 0px 0px 2px"
  }
});